export default __webpack_public_path__ + "static/media/EsignatureResponsiveSmall.50f220f1.png";